import request from '@/utils/request'

export type AlarmClass = 'error' | 'warning'

export interface AlarmSetting {
  id: number
  createdAt?: Date
  updatedAt?: Date

  text: string
  tagUid: string
  digitalAlarm: boolean
  condition: string
  value: number
  threshold: number
  class: AlarmClass

  notifComing: boolean
  notifAck: boolean
  notifGoing: boolean
  // eslint-disable-next-line
  advanced: any
}

export interface AlarmHistory {
  id?: number
  createdAt?: Date
  updatedAt?: Date

  alarmId: number
  ackTime: Date
  goingTime: Date
  ackUserId: number
  status: string
  // eslint-disable-next-line
  values: any[]
  text: string
  class: AlarmClass
  comments: string[]
}

export interface FindAlarmHistoryResult {
  offset: number
  limit: number
  count: number
  data: AlarmHistory[]
}

/**
 * Type untuk menyaring data history alarm
 */
export interface FilterAlarmHistory {
  start: number
  end: number
  class: string
  text: string
  offset: number
  limit: number
  sort: string
}

export function Create(a: AlarmSetting): Promise<AlarmSetting> {
  return request.post('/alarm', a)
}

export function Find(a?: AlarmSetting): Promise<AlarmSetting[]> {
  return request.get('/alarm', { headers: { query: a } })
}

export function Get(id: number): Promise<AlarmSetting> {
  return request.get(`/alarm/${id}`)
}

export function Patch(id: number, al: AlarmSetting) {
  return request.patch(`/alarm/${id}`, al)
}

export function Delete(id: number) {
  return request.delete(`/alarm/${id}`)
}

export function AckAlarm(id: number): Promise<AlarmHistory> {
  return request.patch(`/alarm/${id}/ack`)
}

export function AckAllAlarm(): Promise<AlarmHistory> {
  return request.patch('/alarm/ackAll')
}

export function FindAlarmHistory(
  params: FilterAlarmHistory
): Promise<FindAlarmHistoryResult> {
  let text = ''
  if (params.text != undefined && params.text != '') {
    text = '%' + params.text + '%'
  }

  return request.get('/alarm/history', { params: { ...params, text } })
}

export function GetAlarmHistory(id: number): Promise<AlarmHistory> {
  return request.get(`/alarm/history/${id}`)
}

export function DeleteAlarmHistory(id: number): Promise<AlarmHistory> {
  return request.delete(`/alarm/history/${id}`)
}
